import * as Yup from "yup";

import {
  IValidationObject as IIssueDateValidationObject,
  issueDateSchema,
} from "Components/Features/CheckOut/ProductTile/ProductDetails/CommonProductForms/IssueDate/issueDateFormValidation";

import { ProductTransferFormState } from "Components/Features/CheckOut/ProductTile/ProductDetails/CommonProductForms/ProductTransfer/productTransferFormTypes";
import { TextManager } from "Components/TextContext";
import { Company } from "Store/companies/interfaces";
import { getCompanyNames } from "Store/companies/utils";
import { BooleanFormType } from "Store/interfaces/FormTypes";

type IValidationObject = IIssueDateValidationObject & {
  insuranceShouldBeTransferredFromAnotherCompany: Yup.MixedSchema<BooleanFormType>;
  companyToTransferInsuranceFromName: Yup.StringSchema;
  companyToTransferInsuranceFromOrgNumber: Yup.StringSchema;
};

export const validationObject = (
  insuranceCompanies: Company[],
): IValidationObject => {
  const { getText } = TextManager;
  return {
    insuranceShouldBeTransferredFromAnotherCompany: Yup.mixed<BooleanFormType>()
      .oneOf(Object.values(BooleanFormType))
      .required(
        getText(
          "checkoutforms.validation.insuranceshouldbetransferredfromanothercompany",
        ),
      ),
    issueDate: Yup.date().when(
      "insuranceShouldBeTransferredFromAnotherCompany",
      {
        is: BooleanFormType.FALSE,
        then: (schema) => schema.concat(issueDateSchema()),
      },
    ),
    companyToTransferInsuranceFromName: Yup.string().when(
      "insuranceShouldBeTransferredFromAnotherCompany",
      {
        is: BooleanFormType.TRUE,
        then: (schema) =>
          schema
            .required(
              getText(
                "checkoutforms.validation.companytotransferinsurancefromname",
              ),
            )
            .oneOf(
              getCompanyNames(insuranceCompanies),
              getText(
                "checkoutforms.validation.companytotransferinsurancefromname",
              ),
            ),
      },
    ),
    companyToTransferInsuranceFromOrgNumber: Yup.string(),
  };
};

export const validationSchema = (
  insuranceCompanies: Company[],
): Yup.ObjectSchema<ProductTransferFormState> => {
  return Yup.object(validationObject(insuranceCompanies)).defined();
};
